import { render, staticRenderFns } from "./detailservice.vue?vue&type=template&id=70e5d1c6&"
import script from "./detailservice.vue?vue&type=script&lang=js&"
export * from "./detailservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports